import { CdkNoDataRow } from '@angular/cdk/table';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CarouselIncidentRecordComponent } from 'src/app/components/dashboards/health-safety-control-tower-dashboard/detail-health-safety-control-tower-dashboard/carousel-incident-record/carousel-incident-record.component';
import { CarrouselData, CarrouselDetailData } from 'src/app/domain/carrousel.model';
import { IncidentStatus } from 'src/app/domain/incidentStatus.model';
import { IncidentFilterDto, LastestAlertsFilterDto } from 'src/app/interfaces/Dtos/IncidentFilter.dto';
import { IncidentTypeDto } from 'src/app/interfaces/Dtos/incident-type.dto';
import { DayEventCount, HotSpotMainIncidents, LandingPageDto, MonthEventCount } from 'src/app/interfaces/Dtos/landing-page.dto';
import { SiteDto } from 'src/app/interfaces/Dtos/site.dto';
import { IIncidentsResponse } from 'src/app/interfaces/Responses/IIncidentsResponse';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { NavMenuService } from 'src/app/services/shared/nav-menu.service';
import Chart from 'chart.js/auto'
import * as _ from 'lodash'
import { ISitesResponse } from 'src/app/interfaces/Responses/ISitesResponse';
import { LandingPageDtoRequest } from 'src/app/interfaces/requests/landing-page-dto';
import { IIncidentTypeResponse } from 'src/app/interfaces/Responses/IIncidentsTypesResponse';
import { IIncidentsStatusResponse } from 'src/app/interfaces/Responses/IIncidentsStatusResponse';
import { LandingChartModel } from 'src/app/interfaces/models/landing-chart.model';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BlobStorageUrlService } from 'src/app/services/shared/blob-storage-url.service';
import { environment } from 'src/environments/environment';
import { EventsService } from 'src/app/services/dashboards/events.service';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'neoris-user-data',
  templateUrl: './user-data.component.html',
  styleUrls: ['./user-data.component.css']
})
export class UserDataComponent implements OnInit, OnDestroy {
 


  unusedSiteColor: { color: string, isUsed: boolean }[] =
    [
      { color: "#FFD700", isUsed: false },
      { color: "#8A2BE2", isUsed: false },
      { color: "#FF6347", isUsed: false },
      { color: "#3CB371", isUsed: false },
      { color: "#00BFFF", isUsed: false },
      { color: "#FF1493", isUsed: false },
      { color: "#B22222", isUsed: false },
      { color: "#DAA520", isUsed: false },
      { color: "#B8860B", isUsed: false },
      { color: "#20B2AA", isUsed: false },
      { color: "#F0E68C", isUsed: false },
      { color: "#FF8C00", isUsed: false },
      { color: "#8B008B", isUsed: false },
      { color: "#556B2F", isUsed: false },
      { color: "#FF4500", isUsed: false },
      { color: "#2E8B57", isUsed: false },
      { color: "#D2691E", isUsed: false },
      { color: "#CD5C5C", isUsed: false },
      { color: "#FF7F50", isUsed: false },
      { color: "#6A5ACD", isUsed: false },
      { color: "#B0C4DE", isUsed: false },
      { color: "#FF6347", isUsed: false },
      { color: "#800080", isUsed: false },
      { color: "#FF00FF", isUsed: false },
      { color: "#1E90FF", isUsed: false },
      { color: "#32CD32", isUsed: false },
      { color: "#FFD700", isUsed: false },
      { color: "#DC143C", isUsed: false },
      { color: "#F08080", isUsed: false },
      { color: "#98FB98", isUsed: false },
      { color: "#FF4500", isUsed: false },
      { color: "#C71585", isUsed: false },
      { color: "#00FFFF", isUsed: false },
      { color: "#7FFF00", isUsed: false },
      { color: "#D3D3D3", isUsed: false },
      { color: "#F4A460", isUsed: false },
      { color: "#8B4513", isUsed: false },
      { color: "#2F4F4F", isUsed: false },
      { color: "#B0E0E6", isUsed: false },
      { color: "#FF1493", isUsed: false },
      { color: "#696969", isUsed: false },
      { color: "#A52A2A", isUsed: false },
      { color: "#B22222", isUsed: false },
      { color: "#D2691E", isUsed: false },
      { color: "#FF69B4", isUsed: false },
      { color: "#2C8DFF", isUsed: false }
    ]

  unusedIncidentTypeColor: { color: string, isUsed: boolean }[] =
    [
      { color: "#FFD700", isUsed: false },
      { color: "#8A2BE2", isUsed: false },
      { color: "#FF6347", isUsed: false },
      { color: "#3CB371", isUsed: false },
      { color: "#00BFFF", isUsed: false },
      { color: "#FF1493", isUsed: false },
      { color: "#B22222", isUsed: false },
      { color: "#DAA520", isUsed: false },
      { color: "#B8860B", isUsed: false },
      { color: "#20B2AA", isUsed: false },
      { color: "#F0E68C", isUsed: false },
      { color: "#FF8C00", isUsed: false },
      { color: "#8B008B", isUsed: false },
      { color: "#556B2F", isUsed: false },
      { color: "#FF4500", isUsed: false },
      { color: "#2E8B57", isUsed: false },
      { color: "#D2691E", isUsed: false },
      { color: "#CD5C5C", isUsed: false },
      { color: "#FF7F50", isUsed: false },
      { color: "#6A5ACD", isUsed: false },
      { color: "#B0C4DE", isUsed: false },
      { color: "#FF6347", isUsed: false },
      { color: "#800080", isUsed: false },
      { color: "#FF00FF", isUsed: false },
      { color: "#1E90FF", isUsed: false },
      { color: "#32CD32", isUsed: false },
      { color: "#FFD700", isUsed: false },
      { color: "#DC143C", isUsed: false },
      { color: "#F08080", isUsed: false },
      { color: "#98FB98", isUsed: false },
      { color: "#FF4500", isUsed: false },
      { color: "#C71585", isUsed: false },
      { color: "#00FFFF", isUsed: false },
      { color: "#7FFF00", isUsed: false },
      { color: "#D3D3D3", isUsed: false },
      { color: "#F4A460", isUsed: false },
      { color: "#8B4513", isUsed: false },
      { color: "#2F4F4F", isUsed: false },
      { color: "#B0E0E6", isUsed: false },
      { color: "#FF1493", isUsed: false },
      { color: "#696969", isUsed: false },
      { color: "#A52A2A", isUsed: false },
      { color: "#B22222", isUsed: false },
      { color: "#D2691E", isUsed: false },
      { color: "#FF69B4", isUsed: false },
      { color: "#2C8DFF", isUsed: false }
    ]

  siteColors: { id: number, color: string }[] = [
    { id: 1, color: '#0C6ABF' },
    { id: 2, color: '#003B75' },
    { id: 3, color: '#0C6ABF' },
    { id: 4, color: '#E5EEFA' },
    { id: 5, color: '#B6CAE3' },
    { id: 6, color: '#999999' },
    { id: 7, color: '#E0E0E0' },
    { id: 8, color: '#ED7D31' },
    { id: 9, color: '#4472C4' },
    { id: 10, color: '#E0E0E0' },
    { id: 11, color: '#E0E0E0' },
    { id: 2000, color: '#269FA4' },
    { id: 2001, color: '#388747' },
    { id: 3000, color: '#A68962' },
    { id: 4000, color: '#904D87' },
    { id: 4001, color: '#FF5733' },
    { id: 5000, color: '#33FF57' },
    { id: 5010, color: '#3357FF' },
    { id: 6000, color: '#FF33A1' },
  ]

  private modelHotSpotMainIncidents: HotSpotMainIncidents[] = []
  user: string
  user_principal_name: string
  private lang: string = "en";
  arraySites: any[] = []
  arrayIncidentsTypes: any[] = []
  arrayIncidentStatus: IncidentStatus[] = []
  public lastIncidents: any[] = []
  public cameras: number = 0
  private onLanChange: Subscription
  imageObject: Array<object> = []
  private landingPageDto: LandingPageDto = {
    eventIncidentRecorded: [],
    twelveMonthsEventCount: [],
    sixtingDaysEventCount: [],
    camerasOfflineLast30Days: 0,
    camerasOfflineLast60Days: 0
  }

  private navMenuServiceSubscription: Subscription
  private onIsAllSitesSubscription: Subscription

  private landingChartModel: LandingChartModel = {
    SitesGroup: [],
    EventTypesGroup: [],
    SiteNames: [],
    TotalIncidents: 0
  }

  public landingPageModel: any = {
    camerasOnline: 0,
    CamerasOfflineLastThirtyDays: 0,
    CamerasOfflineEvolution: 0,
    RecordedIncidents: 0,
    incidentsRecordedMonthlyAverage: 0,
    incidentsRecordedVsLastThirtyDays: 0
  }

  constructor(private controltowerservice: ControltowerService,
    private eventsService: EventsService,
    private LocationService: BlobStorageUrlService,
    private breakpointObserver: BreakpointObserver,
    private sanitizer: DomSanitizer,
    private propertiesService: PropertiesTowers,
    public dialog: MatDialog,
    private navMenuService: NavMenuService,
    private translate: TranslateService) {
    this.user = JSON.parse(localStorage.getItem('ud'))[0].value
    this.user_principal_name = JSON.parse(localStorage.getItem('ud'))[1].value
    this.navMenuServiceSubscription = this.navMenuService.siteChangeObservable.subscribe(s => {
      this.getData()
    })
  }

  async ngOnInit() {
    this.propertiesService.clearPropertiesData()
    this.lang = this.translate.defaultLang;

    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      this.lang = s.lang
      this.getData()
    })

    this.onIsAllSitesSubscription = this.propertiesService.IsSelectAllSites$.subscribe((value) => {
      this.getData()
    })
  }

  ngOnDestroy(): void {
    this.navMenuServiceSubscription.unsubscribe()
    this.onLanChange.unsubscribe()
    this.onIsAllSitesSubscription.unsubscribe()
  }

  private async getData() {

    let checkedSites: SiteDto[] = [{ id: Number.parseInt(localStorage.getItem('site')), name: '' }]

    let succesSites = await this.getSites()
    let successIncidents = await this.getIncidentsTypes()
    let successIncidentStatus = await this.getncidentStatus()

    if (succesSites && successIncidents && successIncidentStatus) {

      var blobStorageUrl = await this.LocationService.GetBlobStorageUrlApi();
      environment.authClientId = blobStorageUrl.authClientId
      environment.urlAuth = blobStorageUrl.authUrl
      environment.urlStorageApi = blobStorageUrl.blobStorageUrl

      // environment.authenticateStorageApi = blobStorageUrl.requireAuthenticate

      this.getLastIncidents()

      this.getLandingPageInfo()
    }
  }

  private async getSites(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getSitesForLandingPage().subscribe(
        {
          next: (sites: any) => {

            this.unusedSiteColor.forEach(f => f.isUsed = false)

            this.arraySites = sites.map(m => {

              let color: string = ""
              // let site = sites.find(f => f.id == m.id)
              let siteId = m.id
              let definedColor = this.siteColors.find(f => f.id == siteId)
              if (definedColor != undefined) {
                color = definedColor.color
              } else {
                color = this.unusedSiteColor.find(f => f.isUsed == false).color
                this.unusedSiteColor.find(f => f.isUsed == false).isUsed = true

              }

              return {
                id: m.id,
                name: m.name,
                color: color
              }


            });



            // this.arraySites =

            //   this.arraySites = sites.map(m => {

            //     let color: string = ""
            //     switch (m.id) {
            //       case 1: 
            //         color = '#0C6ABF'
            //         break;
            //       case 2: 
            //         color = '#003B75'
            //         break;
            //       case 3: 
            //         color = '#0C6ABF'
            //         break;
            //       case 4: 
            //         color = '#E5EEFA'
            //         break;
            //       case 5: 
            //         color = '#B6CAE3'
            //         break;
            //       case 6: 
            //         color = '#999999'
            //         break;
            //       case 7: 
            //         color = '#E0E0E0'
            //         break;
            //       case 8: 
            //         color = '#ED7D31'
            //         break;
            //       case 9: 
            //         color = '#4472C4'
            //         break;
            //       case 10: 
            //         color = '#E0E0E0'
            //         break;
            //       case 11: 
            //         color = '#E0E0E0'
            //         break;
            //       case 2000: 
            //         color = '#269FA4'
            //         break;
            //       case 2001: 
            //         color = '#388747'
            //         break;
            //       case 3000: 
            //         color = '#A68962'
            //         break;
            //       case 4000: 
            //         color = '#904D87'
            //         break;
            //     }

            //     return {
            //       id: m.id,
            //       name: m.name,
            //       color: color
            //     }
            //   })

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private incidentTypeColors: { id: number, color: string }[] = [
    { id: 30, color: '#769FBD' },
    { id: 31, color: '#E0E0E0' },
    { id: 32, color: '#0C6ABF' },
    { id: 35, color: '#E5EEFA' },
    { id: 36, color: '#3560AC' },
    { id: 37, color: '#999999' },
    { id: 38, color: '#209787' },
    { id: 39, color: '#ED7D31' },
    { id: 40, color: '#4472C4' },
    { id: 41, color: '#262F56' },
    { id: 42, color: '#904D87' }
  ]

  private async getIncidentsTypes(): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getIncidentsTypes(this.lang).subscribe(
        {
          next: (incidentype: any) => {
            this.unusedIncidentTypeColor.forEach(f => f.isUsed = false)


            this.arrayIncidentsTypes = incidentype.map(m => {

              let color: string = ""
              // let site = sites.find(f => f.id == m.id)
              let incidentTypeId = m.id
              let definedColor = this.incidentTypeColors.find(f => f.id == incidentTypeId)
              if (definedColor != undefined) {
                color = definedColor.color
              } else {
                color = this.unusedIncidentTypeColor.find(f => f.isUsed == false).color
                this.unusedIncidentTypeColor.find(f => f.isUsed == false).isUsed = true

              }

              return {
                id: m.id,
                name: m.name,
                color: color
              }


            });

            // this.arrayIncidentsTypes = incidentype.map(m => {

            //   let color: string = ""
            //   switch (m.id) {
            //     case 30: 
            //       color = '#769FBD'
            //       break;
            //     case 31: 
            //       color = '#E0E0E0'
            //       break;
            //     case 32: 
            //       color = '#0C6ABF'
            //       break;
            //     case 35: 
            //       color = '#E5EEFA'
            //       break;
            //     case 36: 
            //       color = '#3560AC'
            //       break;
            //     case 37: 
            //       color = '#999999'
            //       break;
            //     case 38: 
            //       color = '#209787'
            //       break;
            //     case 39: 
            //       color = '#ED7D31'
            //       break;
            //     case 40: 
            //       color = '#4472C4'
            //       break;
            //     case 41: 
            //       color = '#262F56'
            //       break;
            //     case 42: 
            //       color = '#904D87'
            //       break;
            //   }

            //   return {
            //     id: m.id,
            //     name: m.name,
            //     color: color
            //   }
            // })


            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async getncidentStatus(): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getIncidentsStatus(this.lang).subscribe(
        {
          next: (status: any) => {
            this.arrayIncidentStatus = status
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async getLastIncidents() {
    this.lastIncidents = []

    let now = new Date()
    let threeDaysBefore = new Date()
    threeDaysBefore.setDate(threeDaysBefore.getDate() - 1)
   
    this.getDeviceManagementInfo(this.lang, localStorage.getItem('site'))

     try {
      let checkedSites: SiteDto[] = [{ id: Number.parseInt(localStorage.getItem('site')), name: '' }]
      let filters: LastestAlertsFilterDto = {
        eventTypesId: [35, 36, 38, 39, 41],
        locale_code: this.lang,
        sitesId: checkedSites.map(m => m.id),
        incidentsTypes: this.arrayIncidentsTypes.map(m => m.id),
        statusesId: this.arrayIncidentStatus.map(m => m.id)
      }
      var lastIncidents = await this.getLastestAlerts(filters)
      var notAcceptedClientIdValues : string[] = ['', '.']
      var canGetImages : boolean = true;

      var canGetLatestInfo = notAcceptedClientIdValues.filter(f => f === (environment.authClientId === undefined ? "" : environment.authClientId));

      if(canGetLatestInfo.length > 0){
        lastIncidents.forEach(f => {
          let incident = lastIncidents.find(g => g.eventId == f.eventId)
          const { id: incidentAreaId, name: incidentArea } = incident.incidentArea || { id: null, name: null }
          const { id: siteId, name: siteName } = incident.site || { id: null, name: null }
          this.lastIncidents.push(
                      {
                        isImage: true,
                        eventDescription: incident.eventDescription,
                        occurred: incident.occurred,
                        site: siteName,
                        incidentArea: incidentArea,
                        carrouselModel: null,
                        firstImage: null,
                        // type: firtImage.mediaType,
                        eventId: incident.eventId
                      })

        });

         this.lastIncidents.sort((a, b) => new Date(b.occurred).getTime() - new Date(a.occurred).getTime());
         
        canGetImages = false
      }

    if (lastIncidents != undefined && canGetImages == true) {
      var eventIds = lastIncidents.map(m => m.eventId)
      let eventIdsDto = {
        EventIds: eventIds
      }

      var accessToken = await this.GetAuthToken()
      await this.GetEventsFileNames(eventIdsDto, accessToken)
      this.fileNames.forEach(f => {
        if (f.fileUrls.length > 0) {
          let firstFileUrl = f.fileUrls[0]

          let incident = lastIncidents.find(g => g.eventId == f.eventId)
          const { id: incidentAreaId, name: incidentArea } = incident.incidentArea || { id: null, name: null }
          const { id: siteId, name: siteName } = incident.site || { id: null, name: null }


          this.eventsService.StreamingBlob(firstFileUrl, accessToken).subscribe({
            next: (blob: Blob) => {
              const url = URL.createObjectURL(blob);


              let isImage = this.getFileType(firstFileUrl) === 'image';

              

              let carrouselModel: CarrouselData = {
                images: f.fileUrls
              }

              this.lastIncidents.push(
                      {
                        isImage: isImage,
                        eventDescription: incident.eventDescription,
                        occurred: incident.occurred,
                        site: siteName,
                        incidentArea: incidentArea,
                        carrouselModel: carrouselModel,
                        firstImage: url,
                        // type: firtImage.mediaType,
                        eventId: incident.eventId
                      })

              this.lastIncidents.sort((a, b) => new Date(b.occurred).getTime() - new Date(a.occurred).getTime());



              // this.isImage = this.getFileType(firstFileUrl) === 'image';
              // this.image = this.sanitizer.bypassSecurityTrustUrl(url);
              // this.showCarrousel = true
            },
            error: () => {
              this.lastIncidents.push(
                      {
                        isImage: true,
                        eventDescription: incident.eventDescription,
                        occurred: incident.occurred,
                        site: siteName,
                        incidentArea: incidentArea,
                        carrouselModel: null,
                        firstImage: null,
                        // type: firtImage.mediaType,
                        eventId: incident.eventId
                      })

              this.lastIncidents.sort((a, b) => new Date(b.occurred).getTime() - new Date(a.occurred).getTime());
            }
          })
        }
      })
      // var lastIncidentsImages = await this.getLastestAlertsImages(LastesAlertImagesDTO, accessToken)
      // this.RenderLastIncidents(lastIncidentsImages, lastIncidents);
    }
    }
    catch{
      
    }
  }





  private fileNames: any[] = [];
  private async GetEventsFileNames(eventsIds: any, access_token: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.eventsService.GetEventsFileNames(eventsIds, access_token).subscribe(
        {
          next: (fileNames: any) => {

            this.fileNames = fileNames






             this.fileNames.map(m => {
                  m.fileUrls.sort((a,b)=> {

                    const isMp4 = (url: string) => url.toLowerCase().endsWith('mp4');

                    if(isMp4(a) && !isMp4(b)) return -1;

                    if(!isMp4(a) && isMp4(b)) return 1;

                    return 0;
                  })
            })

            
            console.log("this.fileNames", fileNames)

            resolve(true);
          }, error: (error: HttpErrorResponse) => {

            this.fileNames = []

            resolve(false);
          }
        }
      )
    });
  }

    getFileType(file: string): 'image' | 'video' | 'unknown' {
    const extension = file.split('.').pop()?.toLowerCase();

    if (!extension) return 'unknown';

    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const videoExtensions = ['mp4', 'mov', 'avi', 'wmv', 'mkv', 'webm'];

    if (imageExtensions.includes(extension)) return 'image';
    if (videoExtensions.includes(extension)) return 'video';

    return 'unknown';
  }















  private async GetAuthToken(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.controltowerservice.getAuthIndustrialToken('storage_account', environment.authClientId).subscribe(
        {
          next: (data: any) => {
            resolve(data.access_token);
          }, error: (error: HttpErrorResponse) => {
            resolve(undefined);
          }
        }
      )
    });
  }

  private async getLastestAlerts(filters: LastestAlertsFilterDto): Promise<any> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getLatestAlerts(filters).subscribe(
        {
          next: (incident: any) => {
            resolve(incident);
          }, error: (error: HttpErrorResponse) => {
            resolve(undefined);
          }
        }
      )
    });
  }

  private async getLastestAlertsImages(images: any, access_token: string): Promise<any> {
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getLatestAlertImages(images, access_token).subscribe(
        {
          next: (images: any) => {
            resolve(images);
          }, error: (error: HttpErrorResponse) => {
            resolve(undefined);
          }
        }
      )
    });
  }



  private RenderLastIncidents(incidentImages, lastIncidents) {

    this.lastIncidents = []
    let resultData = lastIncidents;

    resultData.forEach(incident => {

      const { id: incidentAreaId, name: incidentArea } = incident.incidentArea || { id: null, name: null }
      const { id: siteId, name: siteName } = incident.site || { id: null, name: null }

      var _incidentImages = incidentImages.filter(f => f.eventId == incident.eventId)

      if (_incidentImages.length > 0) {
        var firtImage = _incidentImages[0]
        let isImage = firtImage.mediaType == 'image'
        let objectURL = `data:${firtImage.mediaType}/${firtImage.extension};base64,` + firtImage.imageData;
        let image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        let carrouselModel = undefined //this.generateCarrouselData(incident, _incidentImages)

        this.lastIncidents.push(
          {
            isImage: isImage,
            eventDescription: incident.eventDescription,
            occurred: incident.occurred,
            site: siteName,
            incidentArea: incidentArea,
            carrouselModel: carrouselModel,
            firstImage: image,
            type: firtImage.mediaType,
            eventId: incident.eventId
          })
      }

    });
  }

  // private generateCarrouselData(incident: any, _incidentImages: any): CarrouselData {
  //   let imageObjects: CarrouselDetailData[] = []

  //   _incidentImages.forEach(element => {
  //     imageObjects.push({
  //       ImageData: element.imageData,
  //       MediaType: element.mediaType,
  //       Extension: element.extension
  //     })
  //   });

  //   let carrouselModel: CarrouselData = {
  //     images: imageObjects
  //   }

  //   return carrouselModel;
  // }

  private GetEventTypeNameForEventIncidentRecordedData(landingPageData: LandingPageDto) {
    landingPageData.eventIncidentRecorded.map(m => {
      let incidentType = this.arrayIncidentsTypes.find(f => f.id == m.eventTypeId)
      m.eventTypeName = incidentType.name
    })
  }

  private GetEventTypeNameAndSiteNameForTwelveMontsData(landingPageData: LandingPageDto) {
    landingPageData.twelveMonthsEventCount.map(m => {
      let site = this.arraySites.find(f => f.id == m.siteId)
      let incidentType = this.arrayIncidentsTypes.find(f => f.id == m.eventTypeId)
      m.eventTypeName = incidentType.name
      m.siteName = site.name,
        m.color = site.color
    })
  }

  private GetEventTypeNameAndSiteNameForSixtyDaysEvenData(landingPageData: LandingPageDto) {
    landingPageData.sixtingDaysEventCount.map(m => {
      let site = this.arraySites.find(f => f.id == m.siteId)
      let incidentType = this.arrayIncidentsTypes.find(f => f.id == m.eventTypeId)
      m.eventTypeName = incidentType.name
      m.siteName = site.name,
        m.color = site.color
    })
  }

  private GetNumberOfLastRecordedIncidents(): { last60RecordedIncidents: any, lastRecordedIncidents: any } {
    let last60RecordedIncidents = this.landingPageDto.eventIncidentRecorded.map(m => m.last6030Days).reduce((sum, current) => sum + current, 0)
    let lastRecordedIncidents = this.landingPageDto.eventIncidentRecorded.map(m => m.last30Days).reduce((sum, current) => sum + current, 0)

    if (last60RecordedIncidents == undefined) {
      last60RecordedIncidents = 0
    }
    return { last60RecordedIncidents, lastRecordedIncidents }
  }

  private CalculateVsLastThirtyDaysRecordedIncidents(last60RecordedIncidents, lastRecordedIncidents): string {

    let result = '0';

    if (last60RecordedIncidents == 0) {
      result = '0';
    } else {
      let percent = (lastRecordedIncidents * 100) / last60RecordedIncidents
      let evolution = Number((100 - Number(percent || 0)) * -1)
      result = evolution.toFixed(0)
    }


    return result
  }

  private ShowRecordedIncidentsKPI() {
    let { last60RecordedIncidents, lastRecordedIncidents } = this.GetNumberOfLastRecordedIncidents()
    let incidentsRecordedVsLastThirtyDays = this.CalculateVsLastThirtyDaysRecordedIncidents(last60RecordedIncidents, lastRecordedIncidents)

    this.landingPageModel.RecordedIncidents = lastRecordedIncidents
    this.landingPageModel.incidentsRecordedVsLastThirtyDays = incidentsRecordedVsLastThirtyDays
  }

  private GetDatesOfTwelveMontsEvent(): MonthEventCount[] {
    let hsDates = this.landingPageDto.twelveMonthsEventCount.map(m => {
      m.date = new Date(m.year, m.month - 1, 1)
      m.dateString = this.getMonthName(m.month) + ' ' + m.year
      return m
    })

    return hsDates
  }

  private GetMontsToAverageKPI(groupByDates): { month, totalIncidents }[] {
    let monthsToAverage: { month, totalIncidents }[] = []

    Object.keys(groupByDates).forEach(groupDate => {
      groupByDates[groupDate].forEach(f => {
        const exists = monthsToAverage.find(g => g.month == f.month + ' ' + f.year)
        if (exists == undefined) {
          monthsToAverage.push({
            month: f.month + ' ' + f.year,
            totalIncidents: f.nrEvents
          })
        } else {
          exists.totalIncidents += f.nrEvents
        }
      })

    })

    return monthsToAverage
  }

  private getDataToAverageIncidents(): { sumIncidents, totalMonths } {
    let hsDates = this.GetDatesOfTwelveMontsEvent();
    let groupByDates = _.groupBy(hsDates, 'date')
    let monthsToAverage = this.GetMontsToAverageKPI(groupByDates);

    let sumIncidents = monthsToAverage.map(m => m.totalIncidents).reduce((sum, current) => sum + current, 0)
    let totalMonths = monthsToAverage.length

    return { sumIncidents, totalMonths }
  }

  private ShowAverageIncidentsKPI() {
    let { sumIncidents, totalMonths } = this.getDataToAverageIncidents()

    if (sumIncidents > 0) {
      this.landingPageModel.incidentsRecordedMonthlyAverage = Number(sumIncidents / totalMonths).toFixed(0)
    } else {
      this.landingPageModel.incidentsRecordedMonthlyAverage = 0
    }
  }

  private ShowTotalMonthlyIncidentsKPI() {
    this.ShowRecordedIncidentsKPI()
    this.ShowAverageIncidentsKPI()
  }

  private GetCamerasOfflineEvolution(camerasOfflineLast60Days, camerasOfflineLast30Days): string {

    let result = '0'
    if (camerasOfflineLast60Days == 0) {
      result = '0'
    }
    else {
      let CamerasOfflineEvolution = 0
      let CamerasOfflineEvolutionPercentaje = (camerasOfflineLast30Days * 100) / camerasOfflineLast60Days
      CamerasOfflineEvolution = Number((100 - Number(CamerasOfflineEvolutionPercentaje || 0)))
      result = CamerasOfflineEvolution.toFixed(2)
    }

    return result
  }

  private ShowNumberCamerasKPI(landingPageData: LandingPageDto) {
    let CamerasOfflineEvolution = this.GetCamerasOfflineEvolution(landingPageData.camerasOfflineLast60Days, landingPageData.camerasOfflineLast30Days)

    this.landingPageModel.CamerasOfflineLastThirtyDays = landingPageData.camerasOfflineLast30Days
    this.landingPageModel.CamerasOfflineEvolution = CamerasOfflineEvolution
  }

  private ShowKPISData(landingPageData: LandingPageDto) {
    this.ShowNumberCamerasKPI(landingPageData);
    this.ShowTotalMonthlyIncidentsKPI()
  }

  private GetEventAndSiteDataForLandingPageData(landingPageData: LandingPageDto) {
    this.GetEventTypeNameForEventIncidentRecordedData(landingPageData)
    this.GetEventTypeNameAndSiteNameForTwelveMontsData(landingPageData)
    this.GetEventTypeNameAndSiteNameForSixtyDaysEvenData(landingPageData)
  }

  private RenderCharts() {
    this.RenderHotSpotBarChart()
    this.GenerateMainIncidentBarChart()
  }

  private async getLandingPageInfo(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      let sitesId: any[] = localStorage.getItem('site').split(',')

      let LandingPageDtoRequest: LandingPageDtoRequest = {
        userName: this.user_principal_name,
        sitesId: sitesId
      }

      this.controltowerservice.getLandingPageInfo(LandingPageDtoRequest).subscribe(
        {
          next: (landingPageData: LandingPageDto) => {

            this.GetEventAndSiteDataForLandingPageData(landingPageData)
            this.landingPageDto = landingPageData
            this.GroupLandingData(this.landingPageDto.twelveMonthsEventCount)
            this.ShowKPISData(landingPageData);
            this.RenderCharts();

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  private async getDeviceManagementInfo(lang: string, siteId: string): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {

      this.controltowerservice.getDeviceManagement(lang, siteId).subscribe(
        {
          next: (managementInfo: any) => {

            let camerasOnline = 0;
            managementInfo.sites.forEach(site => {
              site.devices.forEach(device => {

                // console.log("device", device)
                if (device.displayed == true) {
                  // console.log("device 1")
                  if (device.deviceType.id == 500) {
                    // console.log("device 2")
                    if (device.sourceDeviceStatusCurrent !== undefined) {
                      // console.log("device 3")
                      if (device.sourceDeviceStatusCurrent.connectionStatus == 'online') {
                        // console.log("device 4")
                        camerasOnline = camerasOnline + 1
                      }
                    }
                  }
                }
              });
            });

            this.landingPageModel.camerasOnline = camerasOnline

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  public openCarousel(CarrouselData: CarrouselData) {

    const isSmall = this.breakpointObserver.isMatched('(max-width: 426px)');

     const dialogConfig = {
      restoreFocus: false,
      data: CarrouselData,
       ...(isSmall
      ? {
        maxWidth: '100vw',
          maxHeight: '100vh'
      } // No tamaños fijos en pantallas pequeñas
      : {
          minWidth: '900px',
          minHeight: '660px',
          maxWidth: '900px',
          maxHeight: '660px'
        })
    };

    this.dialog.open(CarouselIncidentRecordComponent, dialogConfig);
  }

  private readonly months = [
    { MonthName: 'Jan', MonthNumber: 1 },
    { MonthName: 'Feb', MonthNumber: 2 },
    { MonthName: 'Mar', MonthNumber: 3 },
    { MonthName: 'Apr', MonthNumber: 4 },
    { MonthName: 'May', MonthNumber: 5 },
    { MonthName: 'Jun', MonthNumber: 6 },
    { MonthName: 'Jul', MonthNumber: 7 },
    { MonthName: 'Aug', MonthNumber: 8 },
    { MonthName: 'Sep', MonthNumber: 9 },
    { MonthName: 'Oct', MonthNumber: 10 },
    { MonthName: 'Nov', MonthNumber: 11 },
    { MonthName: 'Dec', MonthNumber: 12 }
  ]

  private getMonthName(monthNumber) {
    return this.months.find(f => f.MonthNumber == monthNumber).MonthName
  }

  private DestroyChart(chartName: string) {
    let chartExist = Chart.getChart(chartName);
    if (chartExist != undefined)
      chartExist.destroy();
  }

  private GroupLandingData(twelveMonthsEventCount: MonthEventCount[]) {
    this.landingChartModel.SitesGroup = _.groupBy(twelveMonthsEventCount, 'siteName');
    this.landingChartModel.EventTypesGroup = _.groupBy(twelveMonthsEventCount, 'eventTypeName');
    this.landingChartModel.TotalIncidents = twelveMonthsEventCount.map(m => m.nrEvents).reduce((sum, current) => sum + current, 0)
    this.landingChartModel.SiteNames = Object.keys(this.landingChartModel.SitesGroup)
  }

  private GenerateEventTypeAndSiteDataSet() {
    let ds: { eventTypeName, siteName, incidents }[] = []

    Object.keys(this.landingChartModel.EventTypesGroup).forEach(eventTypeName => {
      this.landingChartModel.EventTypesGroup[eventTypeName].forEach(eventType => {
        let exists = ds.find(f => f.eventTypeName == eventTypeName && f.siteName == eventType.siteName)

        if (exists == undefined) {
          ds.push({
            eventTypeName: eventTypeName,
            siteName: eventType.siteName,
            incidents: eventType.nrEvents
          })

        } else {
          exists.incidents += eventType.nrEvents
        }
      })
    })


    return ds;
  }

  private GeneratePreDataSetForHotSpotBarChart(dsEventType) {
    let arr: { eventTypeName, siteName, incidents }[] = []

    Object.keys(this.landingChartModel.EventTypesGroup).forEach(eventTypeName => {
      this.landingChartModel.SiteNames.forEach(siteName => {
        let eventType = dsEventType[eventTypeName].find(f => f.siteName == siteName)
        if (eventType !== undefined) {
          arr.push(eventType)
        }
        else {
          arr.push({ eventTypeName: eventTypeName, siteName: siteName, incidents: 0 })
        }
      })
    })

    return arr;
  }

  private GenerateDataSetForHotSpotBarChart(arr) {
    let dsByEvent: { eventTypeId, eventTypeName, percent: number[] }[] = []

    arr.forEach(f => {
      let eventType = this.landingPageDto.twelveMonthsEventCount.find(eventType => eventType.eventTypeName == f.eventTypeName)
      let dsByEventExists = dsByEvent.find(f => f.eventTypeId == eventType.eventTypeId)
      let percent = 0

      if (f.incidents > 0) {
        percent = (f.incidents * 100) / this.landingChartModel.TotalIncidents
      }


      if (dsByEventExists == undefined) {
        dsByEvent.push({
          eventTypeId: eventType.eventTypeId,
          eventTypeName: f.eventTypeName,
          percent: [percent]
        })
      } else {
        dsByEventExists.percent.push(percent)
      }
    })

    return dsByEvent
  }

  RenderHotSpotBarChart() {
    this.DestroyChart("hotSpotChar")

    let ds = this.GenerateEventTypeAndSiteDataSet()

    let dsEventType = _.groupBy(ds, 'eventTypeName')

    let preArr = this.GeneratePreDataSetForHotSpotBarChart(dsEventType)

    let dataSet = this.GenerateDataSetForHotSpotBarChart(preArr)

    let datasets: any[] = []
    dataSet.forEach(ds => {
      let color: string = ""
      switch (ds.eventTypeId) {
        case 35:
          color = "#E5EEFA"
          break;
        case 36:
          color = "#262F56"
          break;
        case 38:
          color = "#0C6ABF"

          break;
        case 41:
          color = "#E0E0E0"
          break;
      }

      datasets.push({
        label: ds.eventTypeName,
        data: ds.percent,
        backgroundColor: [
          color
        ],
        borderColor: [
          color
        ],
        borderWidth: 1
      })
    })

    const data = {
      labels: this.landingChartModel.SiteNames,
      datasets: datasets
    };

    Chart.defaults.font.size = 9
    const chart = new Chart("hotSpotChar", {
      type: 'bar',
      data: data,
      options: {
        layout: {
          autoPadding: true
        },
        plugins: {
          legend: {
            align: 'start',
            labels: {
              borderRadius: 4,
              useBorderRadius: true,
              boxWidth: 7,
              boxHeight: 7,
              font: {
                size: 11
              }
            }
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                label = Number(context.formattedValue).toFixed(2) + "%"

                return label;
              }
            }
          }
        },
        indexAxis: 'y',
        scales: {
          x: {
            stacked: true,
            ticks: {
              callback: function (val, index) {
                return val + '%';
              }
            }
          },
          y: {
            stacked: true,
            beginAtZero: true,
          }
        }
      }
    });
  }

  private SortDecendingHsDates(hsDates) {
    return hsDates.sort((a, b) => {
      return a.date.valueOf() - b.date.valueOf()
    })
  }

  private GetFirtsAndLastOfHsDates(dates) {
    const [firstMonthName, firstYear] = Object.keys(dates)[0].split(' ')
    const [lastMonthName, lastYear] = Object.keys(dates).pop().split(' ')

    const firstMonth = this.getMonthNumber(firstMonthName)
    const lastMonth = this.getMonthNumber(lastMonthName)

    let currentMonth = firstMonth.MonthNumber
    let currentYear = Number.parseInt(firstYear)

    return { firstMonth, lastMonth, firstYear, lastYear, currentMonth, currentYear }
  }

  private GetFirtsAndLastOfHsDatesByDay(dates) {

    const [firstMonthName, firstDay, firstYear] = Object.keys(dates)[0].split(' ')
    const [lastMonthName, lastDay, lastYear] = Object.keys(dates).pop().split(' ')

    const firstMonthNumber = this.getMonthNumber(firstMonthName).MonthNumber
    const firstDayNumber = Number.parseInt(firstDay)
    let firstYearNumber = Number.parseInt(firstYear)

    const lastMonthNumber = this.getMonthNumber(lastMonthName).MonthNumber
    let lastDayNumber = Number.parseInt(lastDay)
    let lastYearNumber = Number.parseInt(firstYear)



    return { firstMonthNumber, firstDayNumber, firstYearNumber, lastMonthNumber, lastDayNumber, lastYearNumber }
  }

  private GenerateDateArrayForLinearChart(dates) {

    let { firstMonth, lastMonth, firstYear, lastYear, currentMonth, currentYear } = this.GetFirtsAndLastOfHsDates(dates);

    let dateArr = []
    let generate: boolean = true
    let index: number = 0
    while (generate) {

      dateArr.push(this.getMonthName(currentMonth) + ' ' + currentYear.toString())

      if (currentMonth == lastMonth.MonthNumber && currentYear == Number.parseInt(lastYear)) {
        generate = false
      }

      currentMonth++

      if (currentMonth == 13) {
        currentMonth = 1
        currentYear++
      }

      if (index == 25) {
        generate = false
      }

      index++
    }

    return dateArr;
  }

  private GenerateDateArrayForLinearChartByDay(dates) {

    let { firstMonthNumber, firstDayNumber, firstYearNumber, lastMonthNumber, lastDayNumber, lastYearNumber } = this.GetFirtsAndLastOfHsDatesByDay(dates);

    let currentDate = new Date(firstYearNumber, firstMonthNumber - 1, firstDayNumber);
    const lastDate = new Date(lastYearNumber, lastMonthNumber - 1, lastDayNumber);

    let dateArr = []
    while (currentDate <= lastDate) {
      currentDate.setDate(currentDate.getDate() + 1);

      dateArr.push(this.getMonthName(currentDate.getMonth() + 1) + ' ' + currentDate.getDate() + ' ' + currentDate.getFullYear())

    }
    return dateArr;
  }

  private GroupDateBySiteMonth(dateArr, dates) {
    let dsBySiteMonth: { siteName, month, incidents }[] = []
    const uniqueSiteNames = this.getSiteNamesFromDatesByDay(this.landingPageDto.sixtingDaysEventCount)

    dateArr.forEach(month => {


      var datesMont = dates[month]

      if (datesMont == undefined) {
        uniqueSiteNames.forEach(siteName => {

          dsBySiteMonth.push({
            siteName: siteName,
            month: month,
            incidents: 0
          })
        });

      } else {
        Object.values(datesMont).forEach((dateIncidenst: any) => {
          let existsIncidentSiteDs = dsBySiteMonth.find(f => f.siteName == dateIncidenst.siteName && f.month == month)
          if (existsIncidentSiteDs == undefined) {
            dsBySiteMonth.push({
              siteName: dateIncidenst.siteName,
              month: month,
              incidents: dateIncidenst.nrEvents
            })
          } else {
            existsIncidentSiteDs.incidents += dateIncidenst.nrEvents
          }
        })
      }
    })

    return dsBySiteMonth
  }

  private GetDsBySiteInfo(dateArr, dsBySiteMonth) {

    let totalIncidents = this.landingPageDto.twelveMonthsEventCount.map(m => m.nrEvents).reduce((sum, current) => sum + current, 0)


    let dsBySite: { siteName, totalIncidents, percentajes, incidents }[] = []

    this.landingChartModel.SiteNames.forEach(siteName => {
      dateArr.forEach(monthName => {
        let siteExists = dsBySite.find(f => f.siteName == siteName)
        const dateIncidents = dsBySiteMonth.find(f => f.siteName == siteName && f.month == monthName)

        let incidents: number = 0
        let percentaje: number = 0
        if (dateIncidents !== undefined) {
          incidents = dateIncidents.incidents
        }

        if (incidents > 0) {
          percentaje = (incidents * 100) / totalIncidents
        }

        if (siteExists == undefined) {
          dsBySite.push({
            siteName: siteName,
            totalIncidents: totalIncidents,
            percentajes: [percentaje],
            incidents: [incidents]
          })
        } else {
          siteExists.percentajes.push(percentaje)
          siteExists.incidents.push(incidents)
        }
      })
    })

    return dsBySite
  }

  private GetDsBySiteInfoByDay(dateArr, dsBySiteDays) {

    let totalIncidents = this.landingPageDto.sixtingDaysEventCount.map(m => m.nrEvents).reduce((sum, current) => sum + current, 0)


    let dsBySite: { siteName, totalIncidents, percentajes, incidents }[] = []

    this.landingChartModel.SiteNames.forEach(siteName => {
      dateArr.forEach(date => {

        var datePart = date.split(' ')
        var year = Number.parseInt(datePart[2])
        var month = this.getMonthNumber(datePart[0]).MonthNumber
        var day = Number.parseInt(datePart[1])

        let siteExists = dsBySite.find(f => f.siteName == siteName)
        const dateIncidents = dsBySiteDays.find(f => f.siteName == siteName && f.year == year && f.month == month && f.day == day)

        let incidents: number = 0
        let percentaje: number = 0
        if (dateIncidents !== undefined) {
          incidents = dateIncidents.incidents
        }

        if (incidents > 0) {
          percentaje = (incidents * 100) / totalIncidents
        }

        if (siteExists == undefined) {
          dsBySite.push({
            siteName: siteName,
            totalIncidents: totalIncidents,
            percentajes: [percentaje],
            incidents: [incidents]
          })
        } else {
          siteExists.percentajes.push(percentaje)
          siteExists.incidents.push(incidents)
        }
      })
    })

    return dsBySite
  }

  private generateDataSetForLinearChart(dsBySite) {
    let datasets: { label, data, backgroundColor, borderColor, borderWidth }[] = []

    dsBySite.forEach(f => {

      const site = this.arraySites.find(g => g.name == f.siteName)

      datasets.push({
        label: f.siteName,
        data: f.incidents,
        backgroundColor: [
          site.color
        ],
        borderColor: [
          site.color
        ],
        borderWidth: 1
      })
    })

    return datasets
  }

  private generateDataSetForLinearChartByDay(dsBySite) {
    let datasets: { label, data, backgroundColor, borderColor, borderWidth }[] = []

    dsBySite.forEach(f => {

      const site = this.arraySites.find(g => g.name == f.siteName)

      datasets.push({
        label: f.siteName,
        data: f.incidents,
        backgroundColor: [
          site.color
        ],
        borderColor: [
          site.color
        ],
        borderWidth: 1
      })
    })

    return datasets
  }

  private RenderLinearChart(datasets, dateArr) {
    Chart.defaults.font.size = 9
    const chart = new Chart("hotSpotChar", {
      type: 'line',
      data: {
        labels: dateArr,
        datasets: datasets
      },
      options: {
        layout: {
          autoPadding: true
        },
        plugins: {
          legend: {
            align: 'start',
            labels: {
              borderRadius: 4,
              useBorderRadius: true,
              boxWidth: 7,
              boxHeight: 7,
              font: {
                size: 11
              }
            }
          }
        },
        indexAxis: 'x',
      }
    });
  }

  GenerateLinearChart() {
    this.DestroyChart("hotSpotChar")
    let hsDates = this.GetDatesOfTwelveMontsEvent();
    if (hsDates.length > 0) {
      let hsSortedByDate = this.SortDecendingHsDates(hsDates)
      const dates = _.groupBy(hsSortedByDate, 'dateString')
      let dateArr = this.GenerateDateArrayForLinearChart(dates)
      let dsBySiteMonth = this.GroupDateBySiteMonth(dateArr, dates)
      let dsBySite = this.GetDsBySiteInfo(dateArr, dsBySiteMonth)
      let datasets = this.generateDataSetForLinearChart(dsBySite)

      console.log("GenerateLinearChart", datasets)
      this.RenderLinearChart(datasets, dateArr)
    }

  }

  GenerateLinearChartByDay() {
    this.DestroyChart("hotSpotChar")
    let hsDates = this.GetDatesOfThirtyDaysEvent();

    if (hsDates.length > 0) {
      let hsSortedByDate = this.SortDecendingHsDates(hsDates)
      const dates = _.groupBy(hsSortedByDate, 'dateString')
      let dateArr = this.GenerateDateArrayForLinearChartByDay(dates)
      let dsBySiteDay = this.GroupDateBySiteDay(dateArr, dates)

      let dsBySite = this.GetDsBySiteInfoByDay(dateArr, dsBySiteDay)

      console.log("dsBySite", dsBySite)
      let datasets = this.generateDataSetForLinearChartByDay(dsBySite)

      console.log("GenerateLinearChartByDay", datasets)
      this.RenderLinearChart(datasets, dateArr)
    }
  }

  private GetDatesOfThirtyDaysEvent(): DayEventCount[] {
    let hsDates = this.landingPageDto.sixtingDaysEventCount.map(m => {
      m.date = new Date(m.year, m.month - 1, m.day)
      m.dateString = this.getMonthName(m.month) + ' ' + m.day + ' ' + m.year
      return m
    })

    return hsDates
  }

  getSiteNamesFromDatesByDay(info): string[] {

    const sites = _.groupBy(this.landingPageDto.twelveMonthsEventCount, 'siteName');
    const siteNames = Object.keys(sites)
    return siteNames
  }


  private GroupDateBySiteDay(dateArr, dates) {

    const uniqueSiteNames = this.getSiteNamesFromDatesByDay(this.landingPageDto.sixtingDaysEventCount)

    let dsBySiteDay: { siteName, year, month, day, incidents }[] = []


    var index: number = 0;
    dateArr.forEach(date => {
      var incidentForDates = dates[date];
      var datePart = date.split(' ')



      if (incidentForDates == undefined) {
        uniqueSiteNames.forEach(siteName => {
          dsBySiteDay.push({
            siteName: siteName,
            year: datePart[2],
            month: this.getMonthNumber(datePart[0]).MonthNumber,
            day: Number.parseInt(datePart[1]),
            incidents: 0
          })
        });
      } else {

        Object.values(incidentForDates).forEach((dateIncidenst: any) => {
          var datePart = date.split(' ')
          var year = Number.parseInt(datePart[2])
          var month = this.getMonthNumber(datePart[0]).MonthNumber
          var day = Number.parseInt(datePart[1])

          let existsIncidentSiteDs = dsBySiteDay.find(f => f.siteName == dateIncidenst.siteName && f.month == month && f.day == day && f.year == year)

          if (existsIncidentSiteDs == undefined) {
            dsBySiteDay.push({
              siteName: dateIncidenst.siteName,
              year: year,
              month: month,
              day: day,
              incidents: dateIncidenst.nrEvents
            })
          } else {
            existsIncidentSiteDs.incidents += dateIncidenst.nrEvents
          }

        });
      }

      index++
    });

    return dsBySiteDay
  }


  /*---------------------Bar Chart--------------------------*/

  private GroupTwelveMontsEventDataForChart() {
    const sites = _.groupBy(this.landingPageDto.twelveMonthsEventCount, 'siteName');
    const eventTypes = _.groupBy(this.landingPageDto.twelveMonthsEventCount, 'eventTypeName');
    const siteNames = Object.keys(sites)
    const eventTypeNames = Object.keys(eventTypes)

    return { eventTypes, siteNames, eventTypeNames }
  }

  private GroupTwelveMontsEventDataByEventSite(eventTypeNames, siteNames, eventTypes) {

    let pre_group: { eventTypeName, eventTypeId, siteName, incidentSites }[] = []
    let incidentByEventSite: { eventTypeName, eventTypeId, siteName, Incidents }[] = []

    eventTypeNames.forEach(eventTypeName => {
      siteNames.forEach(siteName => {

        const incidentSites = eventTypes[eventTypeName].filter(f => f.siteName == siteName)

        pre_group.push({
          eventTypeName: eventTypeName,
          eventTypeId: 0,
          siteName: siteName,
          incidentSites: incidentSites
        })
      })
    })


    pre_group.forEach(pre_group_item => {
      pre_group_item.incidentSites.forEach(incident => {
        const incidentByEventSiteExists = incidentByEventSite.find(f => f.siteName == pre_group_item.siteName && f.eventTypeName == pre_group_item.eventTypeName)
        if (incidentByEventSiteExists == undefined) {
          incidentByEventSite.push({
            eventTypeName: pre_group_item.eventTypeName,
            eventTypeId: 0,
            siteName: pre_group_item.siteName,
            Incidents: incident.nrEvents
          })
        } else {
          incidentByEventSiteExists.Incidents += incident.nrEvents
        }
      });

      if (pre_group_item.incidentSites.length > 0) {
        incidentByEventSite.push({
          eventTypeName: pre_group_item.eventTypeName,
          eventTypeId: 0,
          siteName: pre_group_item.siteName,
          Incidents: 0
        })
      }

    })

    return incidentByEventSite
  }

  private GroupTwelveMontsEventDataBySite(siteNames, eventTypeNames, incidentByEventSite) {
    let incidentBySite: { siteName, totalIncidents?, Incidents }[] = []

    siteNames.forEach(siteName => {
      eventTypeNames.forEach(eventTypeName => {
        let incidentBySiteExists = incidentBySite.find(f => f.siteName == siteName)
        let incidents = incidentByEventSite.find(f => f.siteName == siteName && f.eventTypeName == eventTypeName)

        if (incidents !== undefined) {
          if (incidentBySiteExists == undefined) {
            incidentBySite.push({
              siteName: siteName,
              Incidents: [incidents.Incidents]
            })
          } else {
            incidentBySiteExists.Incidents.push(incidents.Incidents)
          }
        }

      })
    })

    return incidentBySite
  }

  private generateArrayDataForBarChart(eventTypeNames, incidentBySite) {
    let arrayData = []
    for (let index = 0; index < eventTypeNames.length; index++) {
      let totalIncidents: number = 0
      incidentBySite.forEach(f => {
        totalIncidents += f.Incidents[index]
      })

      arrayData.push({
        label: eventTypeNames[index],
        totalIncidents: totalIncidents
      })
    }

    return arrayData;
  }

  private generateDataSetAndLabelsForBarChart(incidentBySite, arrayData) {
    let datasets: any[] = []
    let sortLabels: string[] = []

    incidentBySite.forEach(siteIncidents => {

      const site = this.arraySites.find(f => f.name == siteIncidents.siteName)
      let arrayOfObj = arrayData.map(function (d, i) {
        return {
          label: d.label,
          totalIncidents: d.totalIncidents,
          data: siteIncidents.Incidents[i] || 0
        };
      });

      let sortedArrayOfObj = arrayOfObj.sort((a, b) => (a.totalIncidents > b.totalIncidents ? -1 : 1));

      if (sortLabels.length == 0) {
        sortLabels = sortedArrayOfObj.map(m => m.label)
      }

      let sortIncidents = sortedArrayOfObj.map(m => m.data)

      datasets.push({
        label: siteIncidents.siteName,
        data: sortIncidents,
        backgroundColor: [
          site.color
        ],
        borderColor: [
          site.color
        ],
        borderWidth: 1
      })
    })

    return { datasets, sortLabels }
  }

  private RenderMainIncidentBarChart(sortLabels, datasets) {
    const data = {
      labels: sortLabels,
      datasets: datasets
    };

    Chart.defaults.font.size = 9
    const chart = new Chart("mainIncidentChart", {
      type: 'bar',
      data: data,
      options: {
        layout: {
          autoPadding: true
        },
        plugins: {
          legend: {
            align: 'start',
            labels: {
              borderRadius: 4,
              useBorderRadius: true,
              boxWidth: 7,
              boxHeight: 7,
              font: {
                size: 11
              }
            }
          }
        },
        indexAxis: 'y',
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true,
            beginAtZero: true
          }
        }
      }
    });
  }

  GenerateMainIncidentBarChart() {
    this.DestroyChart("mainIncidentChart")
    let { eventTypes, siteNames, eventTypeNames } = this.GroupTwelveMontsEventDataForChart()
    let incidentByEventSite = this.GroupTwelveMontsEventDataByEventSite(eventTypeNames, siteNames, eventTypes)
    let incidentBySite = this.GroupTwelveMontsEventDataBySite(siteNames, eventTypeNames, incidentByEventSite)
    let arrayData = this.generateArrayDataForBarChart(eventTypeNames, incidentBySite)
    let { datasets, sortLabels } = this.generateDataSetAndLabelsForBarChart(incidentBySite, arrayData)
    this.RenderMainIncidentBarChart(sortLabels, datasets)
  }

  private getMonthNumber(monthName) {
    return this.months.find(f => f.MonthName == monthName)
  }
}
